import React from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Stack,
  Link,
  Divider,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  Twitter,
  Email,
  LocationOn,
  WhatsApp,
} from "@mui/icons-material";
import logo from "../../assets/logo2.png";

const Footer = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #1b2d27, #A1C298)",
        color: "#fff",
        padding: "1rem 1rem",
        mt: 5,
        borderTopLeftRadius: "100px",
        borderTopRightRadius: "100px",
      }}
    >
    <Grid
  container
  spacing={4}
  justifyContent="center"
  alignItems="center"
  textAlign="center" // center text by default
>
  {/* Logo and Description */}
  <Grid item xs={12} md={4}>
    <Stack direction="column" alignItems="center" spacing={2}>
      <Box
        component="img"
        src={logo}
        alt="Plant Nursery Logo"
        sx={{ width: 130, borderRadius: "12px" }}
      />
      <Typography
        variant="body1"
        sx={{
          color: "#e0f2e9",
          maxWidth: 280,
          fontFamily: "Poppins",
        }}
      >
        Growing nature with love and care. Discover the green in you!
      </Typography>
    </Stack>
  </Grid>

  {/* Social Media Links */}
  <Grid item xs={12} md={3}>
    <Stack direction="column" alignItems="center" spacing={2}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Follow Us
      </Typography>
      <Stack direction="row" spacing={2}>
        {[Facebook, Instagram, Twitter, WhatsApp, Email].map((Icon, idx) => (
          <IconButton
            key={idx}
            sx={{
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
              transition: "0.3s",
              "&:hover": {
                backgroundColor: "#ffffff",
                color: "#5D9C59",
                transform: "scale(1.1)",
              },
            }}
          >
            <Icon />
          </IconButton>
        ))}
      </Stack>
    </Stack>
  </Grid>

  {/* Branch Locations */}
  <Grid item xs={12} md={3}>
    <Stack spacing={1} alignItems="center">
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Our Branches
      </Typography>
      <Divider sx={{ width: "60%", mb: 1 }} />
      {[
        {
          name: "Zefta",
          link: "https://maps.app.goo.gl/jBfCXY6thXzJacUD7?g_st=com.google.maps.preview.copy",
        },
        {
          name: "Abaa",
          link: "https://maps.app.goo.gl/iSzPFqecFuLi3yb29?g_st=com.google.maps.preview.copy",
        },
        {
          name: "Chtoura main road",
          link: "https://www.google.com/maps/place//@33.8069191,35.8600922,17z/data=!4m6!1m5!3m4!2zMzPCsDQ4JzI0LjkiTiAzNcKwNTEnNDUuNiJF!8m2!3d33.8069191!4d35.8626671?entry=ttu",
        },
      ].map((branch, idx) => (
        <Typography
          key={idx}
          variant="body2"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <LocationOn fontSize="small" />
          <Link
            href={branch.link}
            target="_blank"
            sx={{
              color: "#e0f2e9",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
                color: "#ffffff",
              },
            }}
          >
            {branch.name}
          </Link>
        </Typography>
      ))}
    </Stack>
  </Grid>
</Grid>


      {/* Bottom Footer Text */}
      <Box mt={6} textAlign="center">
        <Typography variant="body2" sx={{ color: "#d7f1e0" }}>
          © {new Date().getFullYear()} Plant Nursery. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
